import { useMemo, useRef } from 'react';

import { useNonFavouritedExchanges } from './useNonFavouritedExchanges';

export const useNonFavouritedExchangeIds = () => {
  const nonFavouritedExchanges = useNonFavouritedExchanges();
  const previousResultRef = useRef<string[]>([]);
  const previousKeyRef = useRef<string>('');

  return useMemo(() => {
    const currentIds = nonFavouritedExchanges.map(bookmaker => bookmaker.code);
    const currentKey = currentIds.join(',');

    if (currentKey === previousKeyRef.current) {
      return previousResultRef.current;
    }

    previousResultRef.current = currentIds;
    previousKeyRef.current = currentKey;
    return currentIds;
  }, [nonFavouritedExchanges]);
};
